import { Flex, HStack, Link, Text, Tooltip } from '@chakra-ui/react';

import { NavLink as RouterLink } from 'react-router-dom';

import { ExternalLinkOutline, InfoCircleOutline } from '@aslanpay/portal-common-lib';

import TextWithClipboard from '../TextWithClipboard';

import { ProfileFieldProps } from './types';

function ProfileField({
  label,
  value,
  tooltip = '',
  link = '',
  externalLink = '',
  isHighlighted = false,
  copyToClipboard = false,
}: ProfileFieldProps) {
  return (
    <Flex gap="5px" flexDir="column" w="full">
      <Flex align="center" gap="6px">
        <Text
          color="brand.black"
          textStyle={isHighlighted ? 'extraSmallBold' : 'extraSmallRegular'}
        >
          {label}
        </Text>
        {tooltip && (
          <Tooltip hasArrow shouldWrapChildren arrowPadding={0} placement="top" label={tooltip}>
            <Flex>
              <InfoCircleOutline boxSize="24px" color="brand.darkGray" cursor="pointer" />
            </Flex>
          </Tooltip>
        )}
      </Flex>
      <HStack>
        {copyToClipboard ? (
          <TextWithClipboard addVerticalSpacing value={value?.toString() || ''} />
        ) : (
          <>
            <Text
              py="15px"
              color="brand.black"
              textStyle={isHighlighted ? 'smallSemiBold' : 'smallMedium'}
              wordBreak="break-word"
            >
              {link && value ? (
                <Link as={RouterLink} to={link} color="brand.purple">
                  {value}
                </Link>
              ) : (
                value || '-'
              )}
            </Text>

            {!!externalLink && (
              <Link href={externalLink} target="_blank" color="brand.purple" display="flex">
                <ExternalLinkOutline boxSize="16px" />
              </Link>
            )}
          </>
        )}
      </HStack>
    </Flex>
  );
}

export default ProfileField;
